module.exports = __webpack_public_path__ + "img/ep3-2-3.4efbcce8.png";